import { Component, createRef } from 'react';
import { ReplaySubject, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';

import { IOC_TYPES } from '../../context/ioc.types';
import { container } from '../../context/module';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { FileSelectEvent } from '../../types/file-upload.types';
import { PageData } from '../../types/route-types';
import { BrowserUtils } from '../../ui-utils/browser-utils';
import { UIUtils } from '../../utils/dom-utils';
import FileUploadComponent from '../converter/file-upload/file-upload.component';

// import styles from './image-compress.component.scss';
export default class ImageCompressComponent extends Component<any> {
    public title: string;
    public description: string;
    public features: Array<any>;
    accept = '*';

    file;
    image;
    compressedImage;
    imageURL: string;
    compressedImageURL: string;
    mousedown = false;
    imageDim = { height: 0, width: 0, left: 0, top: 0 };
    convertedImageURLList = [];
    result = {
        original: 0,
        compressed: 0,
    };

    qualityChangeEvent = new ReplaySubject<any>();

    previewContainer = createRef<HTMLDivElement>()
    actualImage = createRef<HTMLImageElement>()
    partialImagePreview = createRef<HTMLElement>()
    imagePreviewLeft = createRef<HTMLElement>()
    imagePreviewRight = createRef<HTMLElement>()
    handler = createRef<HTMLDivElement>()
    canvas = createRef<HTMLCanvasElement>()

    private pageDataProviderService: PageDataProviderService;

    constructor(props) {
        super(props);
        this.pageDataProviderService = container.get(PageDataProviderService);
        try {
            if (BrowserUtils.hasWindow()) {
                this.image = new Image();
                this.compressedImage = new Image();
                this.image.onload = ($event) => {
                    const canvas: HTMLCanvasElement = this.canvas.current;
                    const ctx = canvas.getContext('2d');
                    canvas.height = this.image.height;
                    canvas.width = this.image.width;
                    ctx.drawImage(this.image, 0, 0);
                    UIUtils.setStyle(this.imagePreviewLeft.current, 'background-image', `url('${this.image.src}')`);
                    this.imageReady();
                    this.qualityChange(75);
                };
                this.compressedImage.onload = () => {
                    URL.revokeObjectURL(this.compressedImageURL);
                    this.compressedImageURL = this.compressedImage.src;
                    UIUtils.setStyle(this.imagePreviewRight.current, 'background-image', `url('${this.compressedImage.src}')`);
                };

                const de = this.qualityChangeEvent.pipe(debounce(() => timer(100)));
                de.subscribe((quality) => {
                    this.qualityChange(quality);
                });
            }
        } catch (e) {
            console.error(e, {
                extra: {
                    fileUpload: this.image,
                },
            });
        }

    }

    componentDidMount() {
        this.pageDataProviderService.loadFeaturePageDataForProps(this.props as any).subscribe({
            next: (value: PageData) => {
                this.features = value.page_seo.feature;
                this.title = value.page_seo.title;
                this.description = value.page_seo.description && value.page_seo.description.replace(/\s+/g, ' ');
            }
        });
    }

    qualityChange(event) {
        this.qualityChangeComplete(event);
    }

    qualityChangeComplete(quality) {
        const canvas: HTMLCanvasElement = this.canvas.current;
        canvas.toBlob((blob) => {
            const imageUrl = URL.createObjectURL(blob);
            this.result.compressed = blob.size;
            this.compressedImage.src = imageUrl;
        }, this.file.type, quality / 100);
    }

    multiFileUploadEvent(event: FileSelectEvent) {
        this.file = event.files[0];
        this.result.original = this.file.size;
        /*this.fileReader.onload = ($event) => {
            this.imageURL = URL.createObjectURL(new Blob($event.target.result, { type: this.file.type }));
        };
        this.fileReader.readAsArrayBuffer(this.file);
        */
        this.imageURL = URL.createObjectURL(this.file);
        this.image.src = this.imageURL;
    }

    mouseDown(event: any) {
        this.mousedown = true;
    }

    mouseMove(event: any) {
        const handlerXPosition = (event.pageX || event.touches[0].pageX)
            - this.partialImagePreview.current.getBoundingClientRect().left;
        if (handlerXPosition > 0 && handlerXPosition < this.imageDim.width) {
            const handlerXPercentage = 100 * handlerXPosition / this.imageDim.width;
            UIUtils.setStyle(this.imagePreviewLeft.current, 'width', `${handlerXPercentage}%`);
            UIUtils.setStyle(this.imagePreviewRight.current, 'left', `${handlerXPercentage}%`);
            UIUtils.setStyle(this.imagePreviewRight.current, 'width', `${100 - handlerXPercentage}%`);
            UIUtils.setStyle(this.handler.current, 'left', `${handlerXPercentage}%`);
        }
    }

    mouseUp(event: any) {
        this.mousedown = false;
    }

    // TODO Preact dont have this, need to fix it
    // @HostListener('window:resize')
    imageReady() {
        setTimeout(() => {
            this.imageDim = this.actualImage.current.getBoundingClientRect();
            UIUtils.setStyle(this.partialImagePreview.current, 'height', `${this.imageDim.height}px`);
            UIUtils.setStyle(this.partialImagePreview.current, 'width', `${this.imageDim.width}px`);
        }, 100);
    }

    render() {
        return (
            <div className={`row nav-padding image-compress`}>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 page-heading">
                    <h1 className="title"><b>{this.title}</b></h1>
                    <p className="description secondary-text">{this.description}</p>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    {
                        this.imageURL && <div className="row convert-mode-actions">
                            <div
                                className="col-12 col-sm-4 col-md-4 col-lg-2 convert-mode-action upload-container secondary">
                                <FileUploadComponent {...this.props} fileSelected={e => this.multiFileUploadEvent(e)} acceptedFileTypes={this.accept}
                                    uploadBtnText="Select File" fileSelectButtonClicked={() => console.log('Clicked')}></FileUploadComponent>
                            </div>
                            <div className="col-6 col-sm-1 col-md-1 col-lg-2 convert-mode-action image-quality-label">
                                <label>Image Quality:</label>
                            </div>
                            <div className="col-6 col-sm-3 col-md-3 col-lg-6 convert-mode-action secondary">
                                {/* <ps-slider (change)="qualityChangeEvent.emit($event)" (changeStop)="qualityChangeEvent.emit($event)"
                    [leftPercentage]="75"></ps-slider> */}
                            </div>
                            <div className="col-12 col-sm-4 col-md-4 col-lg-2 convert-mode-action upload-container">
                                <a className="btn btn-primary download-btn" href={this.compressedImageURL}
                                    download={this.file.name}>Download</a>
                            </div>
                        </div>
                    }

                </div>
                {
                    this.imageURL &&
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 image-compress">
                        <div ref={this.previewContainer} className="image-preview-container">
                            <img alt="Preview thumbnail image" ref={this.actualImage} className="image" src={this.imageURL} />
                            <div ref={this.partialImagePreview as any} className="partial-image-container">
                                <div ref={this.imagePreviewLeft as any} className="partial-image left original-image">
                                    <h5 className="size">
                                        {/* TODO Preact need bytaReadable directive */}
                                        <span className="badge badge-warning">{this.result?.original}</span>
                                    </h5>
                                </div>
                                <div ref={this.handler} className="partial-image middle original-image">
                                    <div className="handler" onMouseDown={($event) => this.mouseDown($event)} onTouchStart={($event => this.mouseDown($event))}>
                                        <div className="bar">
                                            ||
                                        </div>
                                        {
                                            // TODO Preact need to fix mouse up on window to disengage the handler
                                            // (window:mousemove)="mouseMove($event)" (window:move)="mouseMove($event)"
                                            // (window:mouseup)="mouseUp($event)" (window:up)="mouseUp($event)"
                                            this.mousedown && <div className="filler">
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div ref={this.imagePreviewRight as any} className="partial-image right compressed-image">
                                    <h5 className="size">
                                        {/* 
                         TODO Preact need to add conditional class 
                        [ngClass]="[(result.original - result.compressed > 0) ? 'badge-success' : 'badge-danger']" 
                        */}
                                        <span className="badge">{this.result?.compressed}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!this.imageURL && <div className="hidden-xs hidden-sm hidden-md col-lg-1"></div>}
                {!this.imageURL && <div className="col-12 col-sm-12 col-md-12 col-lg-12 upload-container">
                    <FileUploadComponent {...this.props} fileSelected={e => this.multiFileUploadEvent(e)} acceptedFileTypes={this.accept}
                        uploadBtnText="Upload JPG image" fileSelectButtonClicked={() => console.log('Clicked')}></FileUploadComponent>
                </div>}
                {!this.imageURL && <div className="hidden-xs hidden-sm hidden-md col-lg-1"></div>}
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                        {
                            this.features && this.features.map((feature) => {
                                return <div className="col-12 col-sm-12 col-md-6 col-lg-4 feature">
                                    <div className="icon">
                                        {feature.icon}
                                        {/* <m-svg className="mi-2x" name="{{feature.icon}}"></m-svg> */}
                                    </div>
                                    <div className="title ellipsis">{feature.title}</div>
                                    <div className="description">{feature.description}</div>
                                </div>
                            })
                        }

                    </div>
                </div>
                <canvas ref={this.canvas}></canvas>
            </div>
        )
    }
}
